(function () {
  function isMobRoutinePeek() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function initRoutineCarousel(wrap) {
    if (!wrap || wrap.dataset.csLpRoutineCarouselBound === 'true') return;
    wrap.dataset.csLpRoutineCarouselBound = 'true';

    var track = wrap.querySelector('[data-cs-lp-routine-track]');
    var prev = wrap.querySelector('[data-cs-lp-routine-prev]');
    var next = wrap.querySelector('[data-cs-lp-routine-next]');
    if (!track) return;

    function getCards() {
      return track.querySelectorAll('.cs-lp-routine__step-card');
    }

    function getActiveIndex() {
      var cards = getCards();
      if (!cards.length) return 0;

      if (isMobRoutinePeek()) {
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var closest = 0;
        var minDist = Infinity;
        cards.forEach(function (card, i) {
          var rect = card.getBoundingClientRect();
          var cardCenter = rect.left + rect.width / 2;
          var dist = Math.abs(cardCenter - center);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        return closest;
      }

      var scrollLeft = track.scrollLeft;
      var closestIndex = 0;
      var minOffset = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - scrollLeft);
        if (dist < minOffset) {
          minOffset = dist;
          closestIndex = i;
        }
      });
      return closestIndex;
    }

    function syncActiveCard() {
      if (!isMobRoutinePeek()) {
        getCards().forEach(function (card) {
          card.classList.remove('is-lp-active', 'is-lp-adjacent', 'is-lp-away');
        });
        return;
      }

      var cards = getCards();
      if (!cards.length) return;
      var active = getActiveIndex();
      cards.forEach(function (card, i) {
        var isActive = i === active;
        var isAdjacent = Math.abs(i - active) === 1;
        card.classList.toggle('is-lp-active', isActive);
        card.classList.toggle('is-lp-adjacent', !isActive && isAdjacent);
        card.classList.toggle('is-lp-away', !isActive && !isAdjacent);
      });
    }

    function syncButtons() {
      var cards = getCards();
      if (!isMobRoutinePeek()) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }

      var active = getActiveIndex();
      var showNav = cards.length > 1;
      if (prev) {
        prev.hidden = !showNav;
        prev.disabled = !showNav || active <= 0;
      }
      if (next) {
        next.hidden = !showNav;
        next.disabled = !showNav || active >= cards.length - 1;
      }
    }

    function scrollCardToCenter(card) {
      if (!card || !track) return;
      var trackRect = track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var delta = cardRect.left + cardRect.width / 2 - (trackRect.left + trackRect.width / 2);
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      track.scrollTo({
        left: Math.max(0, Math.min(track.scrollLeft + delta, maxScroll)),
        behavior: 'smooth'
      });
    }

    function scrollToIndex(index) {
      var cards = getCards();
      if (!cards.length) return;
      var target = Math.max(0, Math.min(cards.length - 1, index));
      if (isMobRoutinePeek()) {
        scrollCardToCenter(cards[target]);
        window.setTimeout(syncActiveCard, 80);
        window.setTimeout(syncActiveCard, 320);
        window.setTimeout(syncButtons, 320);
        return;
      }
      track.scrollTo({ left: cards[target].offsetLeft, behavior: 'smooth' });
    }

    function scrollBy(dir) {
      scrollToIndex(getActiveIndex() + dir);
    }

    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); scrollBy(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); scrollBy(1); });

    var dragState = { active: false, moved: false, startX: 0, startY: 0 };

    track.addEventListener(
      'pointerdown',
      function (e) {
        if (!isMobRoutinePeek()) return;
        dragState.active = true;
        dragState.moved = false;
        dragState.startX = e.clientX;
        dragState.startY = e.clientY;
      },
      { passive: true }
    );

    track.addEventListener(
      'pointermove',
      function (e) {
        if (!dragState.active) return;
        if (
          Math.abs(e.clientX - dragState.startX) > 8 ||
          Math.abs(e.clientY - dragState.startY) > 8
        ) {
          dragState.moved = true;
        }
      },
      { passive: true }
    );

    track.addEventListener(
      'pointerup',
      function () {
        dragState.active = false;
      },
      { passive: true }
    );

    track.addEventListener(
      'pointercancel',
      function () {
        dragState.active = false;
      },
      { passive: true }
    );

    track.addEventListener('click', function (e) {
      if (!isMobRoutinePeek()) return;
      if (dragState.moved) {
        e.preventDefault();
        dragState.moved = false;
      }
    }, true);

    track.addEventListener(
      'scroll',
      function () {
        syncButtons();
        syncActiveCard();
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        syncButtons();
        syncActiveCard();
      },
      { passive: true }
    );

    syncButtons();
    syncActiveCard();

    if (isMobRoutinePeek()) {
      var cards = getCards();
      if (cards.length) {
        requestAnimationFrame(function () {
          scrollCardToCenter(cards[0]);
          window.setTimeout(syncActiveCard, 80);
          window.setTimeout(syncButtons, 80);
        });
      }
    }
  }

  function initRoutineCheckout() {
    var checkout = document.querySelector('[data-cs-lp-routine-checkout]');
    if (!checkout || checkout.dataset.csLpRoutineCheckoutBound === 'true') return;
    checkout.dataset.csLpRoutineCheckoutBound = 'true';

    var btn = checkout.querySelector('[data-cs-lp-routine-atc]');
    if (!btn) return;

    var variantIds = (checkout.getAttribute('data-variant-ids') || '')
      .split(',')
      .map(function (id) { return parseInt(id, 10); })
      .filter(Boolean);

    if (!variantIds.length) return;

    var defaultLabel = btn.textContent.trim();

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: variantIds.map(function (id) { return { id: id, quantity: 1 }; })
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof window.showCodeskinCartToast === 'function') {
            window.showCodeskinCartToast('Added to your bag', 'success');
          }
          btn.textContent = 'Added to Cart';
          window.setTimeout(function () {
            btn.disabled = false;
            btn.textContent = defaultLabel;
          }, 2000);
        })
        .catch(function (err) {
          console.error('Routine ATC error:', err);
          btn.disabled = false;
          btn.textContent = defaultLabel;
        });
    });
  }

  function bootRoutine() {
    document.querySelectorAll('[data-cs-lp-routine-carousel]').forEach(initRoutineCarousel);
    initRoutineCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootRoutine);
  } else {
    bootRoutine();
  }
})();
